import React, { useEffect, useState } from "react";
import { useLogger } from "@lookiero/sty-psp-logging";
import { asyncKameleoon } from "../AsyncKameleoon";
import { noopKameleoon } from "../NoopKameleoon";
import { hasExperiments } from "../hasExperiments";
import { KameleoonProvider } from "./useKameleoon";
const Kameleoon = ({ siteCode, host, consented, experiments, children }) => {
    const logger = useLogger();
    const [kameleoon, setKameleoon] = useState();
    const enabled = hasExperiments(experiments);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const loadKameleoon = async () => setKameleoon(await asyncKameleoon({ siteCode, host, logger, consented }));
        loadKameleoon();
    }, [enabled, logger, siteCode, host, consented]);
    return React.createElement(KameleoonProvider, { kameleoon: enabled ? kameleoon : noopKameleoon }, children);
};
export { Kameleoon };
